<template>
  <div class="portfolio">
    <div class="portfolio-block">
      <a
        v-for="(item, index) in this.projects"
        :key="index"
        @click="updatePortfolioItem(index)"
        v-bind:class="currentIndex === index ? 'active' : ''"
      >
        <img :src="item.project_logo" alt>
      </a>
    </div>
    <div class="work">
      <transition name="fade" mode="out-in">
        <div class="container" v-if="show">
          <div class="header">
            <h2>{{ currentProject.project }}</h2>
          </div>
          <div class="project">
            <div class="project__about">
              <p>{{ currentProject.project_brief }}</p>
              <div class="built-with">Built With</div>
              <ul class="technology">
                <li v-for="(item, index) in currentProject.technology" :key="index">
                  <i :class="item.icon"></i>
                </li>
              </ul>
              <a
                v-if="currentProject.project_link"
                class="btn"
                :href="currentProject.project_link"
              >Visit Site</a>
            </div>

            <carousel
              :per-page="1"
              class="project__images"
              paginationActiveColor="orangered"
              paginationPosition="bottom-overlay"
            >
              <slide v-for="(slide, index) in currentProject.images" :key="index">
                <img :src="slide.url" :alt="slide.alt" style="display: block">
              </slide>
            </carousel>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import { Carousel, Slide } from "vue-carousel";

export default {
    name: "Profolio",
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            projects: {},
            currentProject: {},
            currentIndex: 0,
            show: true
        };
    },
    methods: {
        updatePortfolioItem(index = 0) {
            this.show = false;
            setTimeout(() => {
                this.currentIndex = index;
                this.currentProject = this.projects[index];
                this.show = true;
            }, 500);
        }
    },
    mounted() {
        axios.get("./project-data.json").then(response => {
            this.projects = response.data;
            this.updatePortfolioItem();
        });
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.fade-enter-active {
    transition: opacity 0.5s ease-out;
}

.fade-leave-active {
    transition: opacity 0.5s ease-out;
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.portfolio-block {
    border-top: 5px solid #012042;

    height: auto;
    background: #012042;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    align-content: center;

    @media only screen and (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: 1fr 1fr;
        min-height: 200px;
        height: 20vh;
    }

    a {
        cursor: pointer;
        transition: 0.25s ease-out all;
        color: white;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem 0.5rem;
        border: 1px solid rgba(255, 255, 255, 0.1);

        @media only screen and (min-width: 768px) {
            padding: 0;
            border: 0;
        }
        &:nth-child(odd) {
            @media only screen and (min-width: 768px) {
                background: rgba(255, 255, 255, 0.1);
            }
        }

        &:hover {
            background: orangered;
        }
        // &.active {
        //     border-bottom: 5px solid orangered;
        // }

        img {
            max-width: 200px;
            max-height: 40px;

            @media only screen and (min-width: 768px) {
                max-height: 80px;
            }
        }
    }
}

.work {
    padding: 0 0 5rem;

    @media only screen and (min-width: 768px) {
        padding: 2rem 0 10rem;
    }

    h2 {
        font-size: 2rem;
        font-weight: 400;
        font-family: magion-web, sans-serif;
        border-bottom: 3px solid orangered;
        text-transform: uppercase;
        font-style: italic;

        @media only screen and (min-width: 768px) {
            font-size: 3rem;
        }
        @media only screen and (min-width: 1200px) {
            font-size: 4rem;
        }
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 1rem;
    }
}

.project {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;

    @media only screen and (min-width: 768px) {
        grid-template-columns: 1fr 3fr;
    }
}

.project__about {
    .built-with {
        font-size: 0.75rem;
        text-transform: uppercase;
        color: #000;
        margin-bottom: 0.5rem;
    }

    .technology {
        padding: 0 0 1rem;
        margin: 0 0 1rem;
        list-style: none;

        li {
            display: inline;
            padding-right: 1rem;
        }
    }

    h3 {
        font-size: 3rem;
        margin: 0;
    }
    p {
        margin: 0 0 1rem;
        font-size: 1rem;
    }

    i {
        font-size: 2rem;
    }

    .btn {
        color: white;
        font-size: 1rem;
        text-decoration: none;
        background: orangered;
        display: inline-block;
        padding: 0.5rem 1rem;
        font-weight: bold;
    }
}

.VueCarousel img {
    border-radius: 0.5rem;
}
</style>
